import { fromJS } from 'immutable';
import { fetchRecentActivityRoutine } from '../routines';

const initialState = fromJS({
  recent: {},
});

export default function (state = initialState, action) {
  // console.log('action', action);
  switch (action.type) {
    case fetchRecentActivityRoutine.TRIGGER:
      return state.set('loading', true);
    case fetchRecentActivityRoutine.SUCCESS:
      return state.set('loading', false)
        .set('recent', fromJS(action.activity || {}));
    case fetchRecentActivityRoutine.FAILURE:
      return state.set('loading', false)
        .set('error', fromJS(action.error));
    default :
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/activity.js